'use strict'

import React from 'react'
import { Box } from '@symbo.ls/react-box'

export const Img = (props) => <Box tag='img' {...props} />
